module.exports = __webpack_public_path__ + "static/media/system_optima.f02cb55a.png";